import React from 'react';
import { MapPin, Phone, Mail, Clock, ExternalLink, ArrowUpRight, Printer } from 'lucide-react';
export function Footer() {
  return <footer data-id="element-59">
      <div className="border-t border-border bg-background pt-16 pb-12" data-id="element-60">
        <div className="container mx-auto px-4" data-id="element-61">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-y-12 gap-x-8" data-id="element-62">
            {/* Brand — 3 cols */}
            <div className="lg:col-span-3" data-id="element-63">
              <img src="https://cdn.magicpatterns.com/uploads/kuZyhrxLAUnbAoqB6LL6kM/FMC-1920w.jpg.webp" alt="Fresno Management Company" className="max-h-14 w-auto object-contain mb-5" data-id="element-64" />
              <p className="text-muted-foreground text-sm leading-relaxed mb-6" data-id="element-65">
                Professional property management for residential, commercial,
                and HOA properties across the Central Valley.
              </p>
              <p className="text-xs text-muted-foreground/60 font-mono" data-id="element-66">
                DRE#01930950
              </p>
            </div>

            {/* Contact — 3 cols */}
            <div className="lg:col-span-3" data-id="element-67">
              <h3 className="text-lg font-medium text-foreground mb-5" data-id="element-68">
                Contact
              </h3>
              <div className="space-y-3.5" data-id="element-69">
                <a href="mailto:Info@FresnoPMC.net" className="flex items-center gap-3 text-sm text-muted-foreground hover:text-foreground transition-colors" data-id="element-70">
                  <Mail className="h-4 w-4 shrink-0 text-primary" data-id="element-71" />
                  Info@FresnoPMC.net
                </a>
                <a href="tel:5594389411" className="flex items-center gap-3 text-sm text-muted-foreground hover:text-foreground transition-colors" data-id="element-72">
                  <Phone className="h-4 w-4 shrink-0 text-primary" data-id="element-73" />
                  <span data-id="element-74">
                    (559) 438-9411{' '}
                    <span className="text-muted-foreground/50 text-xs ml-1" data-id="element-75">
                      Office
                    </span>
                  </span>
                </a>
                <a href="tel:5594389415" className="flex items-center gap-3 text-sm text-muted-foreground hover:text-foreground transition-colors" data-id="element-76">
                  <Printer className="h-4 w-4 shrink-0 text-primary" data-id="element-77" />
                  <span data-id="element-78">
                    (559) 438-9415{' '}
                    <span className="text-muted-foreground/50 text-xs ml-1" data-id="element-79">
                      Fax
                    </span>
                  </span>
                </a>
                <a href="tel:8002201054" className="flex items-center gap-3 text-sm text-muted-foreground hover:text-foreground transition-colors" data-id="element-80">
                  <Phone className="h-4 w-4 shrink-0 text-primary" data-id="element-81" />
                  <span data-id="element-82">
                    (800) 220-1054{' '}
                    <span className="text-muted-foreground/50 text-xs ml-1" data-id="element-83">
                      Toll-Free
                    </span>
                  </span>
                </a>

                <div className="pt-1" data-id="element-84" />

                <div className="flex items-start gap-3 text-sm text-muted-foreground" data-id="element-85">
                  <MapPin className="h-4 w-4 shrink-0 mt-0.5 text-primary" data-id="element-86" />
                  <span data-id="element-87">
                    7575 N Del Mar Ave Ste 102
                    <br data-id="element-88" />
                    Fresno, CA 93711
                  </span>
                </div>
                <div className="flex items-start gap-3 text-sm text-muted-foreground" data-id="element-89">
                  <Clock className="h-4 w-4 shrink-0 mt-0.5 text-primary" data-id="element-90" />
                  <span data-id="element-91">
                    Mon – Fri: 9:00am – 5:00pm
                    <br data-id="element-92" />
                    <span className="text-muted-foreground/50 text-xs" data-id="element-93">
                      Closed 12:00pm – 1:00pm
                    </span>
                  </span>
                </div>
              </div>
            </div>

            {/* Quick Links — 2 cols */}
            <div className="lg:col-span-2" data-id="element-94">
              <h3 className="text-lg font-medium text-foreground mb-5" data-id="element-95">
                Quick Links
              </h3>
              <ul className="space-y-3" data-id="element-96">
                {['Services', 'Vacancies', 'About Us', 'Our Mission', 'Contact', 'Employee Directory'].map(link => <li key={link} data-id="element-97">
                    <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-id="element-98">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </div>

            {/* Portals — 2 cols */}
            <div className="lg:col-span-2" data-id="element-99">
              <h3 className="text-lg font-medium text-foreground mb-5" data-id="element-100">
                Portals
              </h3>
              <div className="space-y-6" data-id="element-101">
                <div data-id="element-102">
                  <p className="text-sm font-medium text-foreground mb-2" data-id="element-103">
                    Tenant Portal
                  </p>
                  <div className="flex gap-4" data-id="element-104">
                    <a href="#" className="inline-flex items-center gap-1 text-sm text-primary hover:underline transition-colors" data-id="element-105">
                      Log In <ArrowUpRight className="h-3 w-3" data-id="element-106" />
                    </a>
                    <a href="#" className="inline-flex items-center gap-1 text-sm text-primary hover:underline transition-colors" data-id="element-107">
                      Sign Up <ArrowUpRight className="h-3 w-3" data-id="element-108" />
                    </a>
                  </div>
                </div>
                <div data-id="element-109">
                  <p className="text-sm font-medium text-foreground mb-2" data-id="element-110">
                    Owner Portal
                  </p>
                  <div className="flex gap-4" data-id="element-111">
                    <a href="#" className="inline-flex items-center gap-1 text-sm text-primary hover:underline transition-colors" data-id="element-112">
                      Log In <ArrowUpRight className="h-3 w-3" data-id="element-113" />
                    </a>
                    <a href="#" className="inline-flex items-center gap-1 text-sm text-primary hover:underline transition-colors" data-id="element-114">
                      Sign Up <ArrowUpRight className="h-3 w-3" data-id="element-115" />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Affiliations — 2 cols */}
            <div className="lg:col-span-2" data-id="element-116">
              <h3 className="text-lg font-medium text-foreground mb-5" data-id="element-117">
                Affiliations
              </h3>
              <div className="flex flex-wrap items-center gap-6" data-id="element-118">
                <img src="https://cdn.magicpatterns.com/uploads/nM9rzfyUr4zFmvn2fTiiPB/caa-logo-e1460673038425-1920w.png.webp" alt="California Apartment Association" className="h-16 w-auto object-contain brightness-[0.2]" data-id="element-119" />
                <img src="https://cdn.magicpatterns.com/uploads/jGhN9KZXGSyNmRx2gJMC2H/equal-house-opp2B(1)-1920w.png.webp" alt="Equal Housing Opportunity" className="h-12 w-auto object-contain brightness-[0.2]" data-id="element-120" />
                <img src="https://cdn.magicpatterns.com/uploads/1cLbEUxEjyMgrb5RQvXD34/fresnomls-white-1920w.png.webp" alt="Fresno MLS" className="h-8 w-auto object-contain brightness-[0.2]" data-id="element-121" />
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="mt-12 pt-6 border-t border-border" data-id="element-122">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-123">
              <p className="text-xs text-muted-foreground/60" data-id="element-124">
                © 2026 All Rights Reserved. Fresno Management Company
                DRE#01930950
              </p>
              <div className="flex items-center gap-4" data-id="element-125">
                {['Sitemap', 'Privacy Policy', 'Terms of Service'].map(link => <a key={link} href="#" className="text-xs text-muted-foreground/60 hover:text-foreground transition-colors" data-id="element-126">
                      {link}
                    </a>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}